import Marquee from "react-fast-marquee";

const WORDS = [
  "NOTTINGHAM",
  "DERBY",
  "MIDLANDS PERFORMANCE TUNING",
  "STAGE 1",
  "STAGE 2",
  "STAGE 3",
  "MOBILE SERVICE",
];

export default function EditorialMarquee() {
  return (
    <div
      className="relative py-8 border-y border-white/10 bg-carbon overflow-hidden"
      data-testid="editorial-marquee"
    >
      <Marquee speed={30} gradient={false} pauseOnHover>
        <div className="flex items-center gap-14 pr-14 font-mono text-[9vw] md:text-[6vw] uppercase tracking-tighter font-black text-white/[0.08]">
          {WORDS.concat(WORDS).map((w, i) => (
            <span key={i} className="flex items-center gap-14 whitespace-nowrap">
              <span>{w}</span>
              <span className="text-volt/40">◆</span>
            </span>
          ))}
        </div>
      </Marquee>
    </div>
  );
}
